import { createRequest } from '@paysera/http-client-common';
import httpClient from '%app/js/httpClient';
import { router } from '%app/js/common/services/router';

class SeatingsClient {
    async* getSeatings(token, options) {
        const filter = { limit: 1000, ...options };
        const request = createRequest(
            'GET',
            router.generate(
                'paysera_seat_selection_integration.seatings.get_by_event',
                { token, ...filter },
            ),
        );

        const {
            items,
            _metadata: { has_next: hasNext },
            _metadata: metadata,
        } = await httpClient.performRequest(request);

        yield [...items];

        if (hasNext) {
            const { cursors: { after } } = metadata;
            yield* this.getSeatings(token, { ...filter, after });
        }
    }

    async* getSubscriptionsOnSale(token, filter = { limit: 100 }) {
        const request = createRequest(
            'GET',
            router.generate(
                'paysera_seat_selection_integration.subscriptions_on_sale.get_by_event',
                { token, ...filter },
            ),
        );

        const {
            items,
            _metadata: { has_next: hasNext },
            _metadata: metadata,
        } = await httpClient.performRequest(request);

        yield [...items];

        if (hasNext) {
            const { cursors: { after } } = metadata;
            yield* this.getSubscriptionsOnSale(token, { ...filter, after });
        }
    }

    async* getAvailableSeatsOfEvent(token, filter = { limit: 1000 }) {
        const request = createRequest(
            'GET',
            router.generate(
                'paysera_seat_selection_integration.seatings.get_available_by_event',
                { token, ...filter },
            ),
        );

        const {
            items,
            _metadata: { has_next: hasNext },
            _metadata: metadata,
        } = await httpClient.performRequest(request);

        yield items;

        if (hasNext) {
            const { cursors: { before: after } } = metadata;
            yield* this.getAvailableSeatsOfEvent(token, { ...filter, after });
        }
    }
}

export default new SeatingsClient();
